module.exports = __webpack_public_path__ + "static/img/google-play-button@3x.b54fb38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play-button@3x.png
// module id = 1097
// module chunks = 5